/**
 * Created by andrey on 15.05.17.
 */

const LevelAttempts = function () {
    const save = cleverapps.dataLoader.load(DataLoader.TYPES.LEVEL_ATTEMPTS);
    this.attempts = save || {};
};

LevelAttempts.prototype.addAttempt = function (level) {
    const levelId = level.getHumanReadableNumber();
    if (this.attempts[levelId] === undefined) {
        this.attempts[levelId] = 0;
    }
    this.attempts[levelId]++;
    this.save();
};

LevelAttempts.prototype.getAttempts = function () {
    const levelId = levels.user.getVirtualLevel();
    return this.attempts[levelId];
};

LevelAttempts.prototype.save = function () {
    let minLevelId = 1000000000, amountAttempts = 0;
    for (const levelId in this.attempts) {
        if (parseInt(levelId) < minLevelId) {
            minLevelId = parseInt(levelId);
        }
        amountAttempts++;
    }

    const MAX_HISTORY = 10;
    if (amountAttempts > MAX_HISTORY) {
        delete this.attempts[minLevelId];
    }
    cleverapps.dataLoader.save(DataLoader.TYPES.LEVEL_ATTEMPTS, this.attempts);
};